import { render, staticRenderFns } from "./top-menu.vue?vue&type=template&id=34bf9e26&scoped=true"
import script from "./top-menu.vue?vue&type=script&lang=js"
export * from "./top-menu.vue?vue&type=script&lang=js"
import style0 from "./top-menu.vue?vue&type=style&index=0&id=34bf9e26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34bf9e26",
  null
  
)

export default component.exports